import React from "react";

export const TaxOutIcon = () => {
	return (
		<svg width="41" height="20" viewBox="0 0 41 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="20" rx="2" fill="#6D7177" />
			<path d="M4.64726 15V6.34568H3V5H8.15885V6.34568H6.53713V15H4.64726Z" fill="white" />
			<path
				d="M8.32685 15L10.3955 5H12.4131L14.4817 15H12.7323L12.3237 12.6914H10.5232L10.1018 15H8.32685ZM10.7147 11.5309H12.1194L11.417 7.33333L10.7147 11.5309Z"
				fill="white"
			/>
			<path
				d="M14.8707 15L16.9521 9.69136L14.9345 5H16.6967L18.0375 8.09877L19.2123 5H20.8468L18.8547 10.037L21 15H19.2378L17.7693 11.642L16.4924 15H14.8707Z"
				fill="white"
			/>
			<path d="M26 10L33.5 4.80385L33.5 15.1962L26 10Z" fill="#6D7177" />
			<rect x="41" y="12" width="10" height="4" transform="rotate(-180 41 12)" fill="#6D7177" />
		</svg>
	);
};
